import PropTypes from 'prop-types';

const cardProgramQuestionsShape = PropTypes.shape({
  atm_access: PropTypes.bool,
  funded_from_trust: PropTypes.bool,
});

export default cardProgramQuestionsShape;
